export default {
  mapLeftClick: {
    placeInfo: 'Informace o místě',
    placeInsidePolygon: 'Místo uvnitř polygonu',
    polygonArea: 'Plocha polygonu',
    copyLnglat: 'Kopírovat lng, lat',
    copyLatlng: 'Kopírovat lat, lng',
    directionsToClickedPoint: 'Instrukce k místu kliknutí',
    lnglatCopied: 'Zeměpisná délka a šířka zkopírována',
    latlngCopied: 'Zeměpisná šířka a délka zkopírována'
  }
}
